<template>
  <exec-report-panel report-name="referrals" title="Referidos" :filters="filters" @error="$emit('error', $event)" />
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 11 · Referidos (doc 04 §3, reporte 11).
export default { name: 'ExecReferrals', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
